import {
    AfterViewChecked, AfterViewInit,
    Component, EventEmitter, OnDestroy,
    OnInit, Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';

@Component({
    selector: 'app-slide-in-panel',
    templateUrl: './slide-in-panel.component.html',
    styleUrls: ['./slide-in-panel.component.scss']
})
export class SlideInPanelComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('content', { read: ViewContainerRef, static: true }) contentRef;
    isVisible = false;
    @Output() onClosed = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.isVisible = true;
        });
    }

    close(e) {
        e.preventDefault();
        this.isVisible = false;
        setTimeout(() => {
            this.onClosed.emit();
        }, 600);
    }

}
